import IconComponent from "@mdi/react";

import { mdiOpenInNew } from "@mdi/js";
import styled from "styled-components";

import { WellDetailCardData } from "api/data";

import { PERMIT_ID_FIELD, reportedName } from "./constants";
import { TEAL } from "./styles";
import { stateFilings } from "./utils/stateFilings";

export interface StateFilingsLinkProps {
  uwi: Maybe<string>;
  wellData: Maybe<WellDetailCardData>;
  /** keepPreviousData still holds the previous well's fields. */
  stale: boolean;
}

export function StateFilingsLink({
  uwi,
  wellData,
  stale
}: StateFilingsLinkProps): Nullable<JSX.Element> {
  // Stale fields carry the previous well's permit number.
  const permitId = stale ? null : reportedName(wellData?.[PERMIT_ID_FIELD])?.trim();
  const filings = stateFilings(uwi, permitId);
  if (!filings) return null;

  return (
    <Link
      {...(filings.href
        ? { href: filings.href, target: "_blank", rel: "noopener noreferrer" }
        : // An `<a>` without `href` has no link role, so `aria-disabled` alone is not announced.
          { role: "link", "aria-disabled": true })}
      data-testid="well-card-state-filings-link">
      State Filings
      <IconComponent path={mdiOpenInNew} size="16px" />
    </Link>
  );
}

const Link = styled.a`
  margin-left: auto;
  align-self: center;
  display: inline-flex;
  align-items: center;
  padding: 0 15px;
  gap: 4px;
  font-size: 1.4rem;
  letter-spacing: 0.5px;
  color: var(--color-icon);
  white-space: nowrap;
  text-decoration: none;

  &[href]:hover {
    color: ${TEAL};
    text-decoration: underline;
  }

  &[aria-disabled="true"] {
    opacity: 0.5;
    cursor: default;
  }
`;
